import { createContext, useRef, useContext, useState, useEffect } from 'react';
import {useJobSwitch} from "@spa/features/search_job/pc/contexts/JobSwitchContext";

const FocusContext = createContext(null);

export const useFocus = () => {
    return useContext(FocusContext);
}

export const FocusProvider = ({ children }) => {
    const focusPanelRefs = useRef({});
    const focusDetailRef = useRef(null);
    const {activeUniqueId, isFirstRender} = useJobSwitch();
    const [focusUniqueId, setFocusUniqueId] = useState(null);

    /**
     * 詳細表示されている求人のuniqueIdが変更された場合、フォーカスを移動する
     * 初回はパネルにフォーカスを当てる
     * 2回目以降は詳細にフォーカスを当てる
     */
    useEffect(() => {
        if (isFirstRender) {
            moveFocusToPanel(activeUniqueId);
        } else {
            moveFocusToDetail();
        }
    }, [activeUniqueId]);

    /**
     * パネルにフォーカスを移動
     */
    const moveFocusToPanel = (uniqueId) => {
        focusPanelRefs.current[uniqueId]?.focus();
    }

    /**
     * 詳細にフォーカスを移動
     */
    const moveFocusToDetail = () => {
        focusDetailRef.current.focus();
    }

    const value = {
        focusPanelRefs,
        focusDetailRef,
        moveFocusToPanel,
        moveFocusToDetail,
        focusUniqueId,
        setFocusUniqueId,
    }

    return (
        <FocusContext.Provider value={value}>
            {children}
        </FocusContext.Provider>
    );
}
